// [\uFF71-\uFF9F]: 半角カナ（小文字とヲを除く）、濁点、半濁点
// [A-Z]: 英大文字
// [0-9]: 数字
// [ ]: スペース
// [-]: 店舗名に使える記号類
// [()-.]: 口座名等に使える記号4種類

export const bankNameRegex = /^[\uFF71-\uFF9FA-Z0-9-]+$/;
export const bankBranchNameRegex = bankNameRegex;
export const bankAccountHolderNameRegex = /^[\uFF71-\uFF9FA-Z0-9 ()-.]+$/;
